export function unexhaustiveError(msg: string): never {
  // the type system ensures we will never actually reach this throw
  // hence the usage of the never type here.
  // The benefit of this approach is that we get exhaustiveness checks
  // for switch statements at compile time.
  throw new Error(msg);
}
